import { useLoaderData, Navigate } from "react-router-dom";

import AnalyticsChartsSection from "../../../components/modules/analytics/components/AnalyticsChartsSection";
import AnalyticsHeaderSection from "../../../components/modules/analytics/components/AnalyticsHeaderSection";
import AnalyticsReportsSection from "../../../components/modules/analytics/components/AnalyticsReportsSection";

export default () => {
  const { analytics, error } = useLoaderData();

  if (error) {
    return <Navigate to="/not-found" replace />;
  }

  const { name = "", description = "", chartsSection = [], reportsSection = [] } = analytics;

  return (
    <div className="flex flex-wrap w-full h-auto gap-4">
      <AnalyticsHeaderSection title={name} description={description} />

      <AnalyticsChartsSection chartsSection={chartsSection} />

      <AnalyticsReportsSection reportsSection={reportsSection} />
    </div>
  );
};
